import {
  DesktopIcon,
  GlobeIcon,
  SewingPinFilledIcon,
  ActivityLogIcon,
  ArchiveIcon,
  FileTextIcon,
  LightningBoltIcon,
  BarChartIcon,
} from "@radix-ui/react-icons";
import { GoTerminal } from "react-icons/go";
import { MdOutlineSimCardDownload } from "react-icons/md";

import type { MenuItem } from "./types";

export const LEAD_VIEWS_ITEMS: MenuItem[] = [
  {
    href: "/location-intelligence",
    title: "Municipal landscape",
    description: "Explore SCB workplace coverage by municipality and industry.",
    icon: <SewingPinFilledIcon />,
  },
  {
    href: "/likely-match",
    title: "New locations",
    description: "Newly listed locations with likely company to move.",
    icon: <SewingPinFilledIcon />,
  },
  {
    href: "/buzz",
    title: "Buzz",
    description: "Get insights from the latest articles.",
    icon: <GlobeIcon />,
  },
  {
    href: "/hiring-trends",
    title: "Hiring trends",
    description: "Compare verified hiring keywords and explore the companies and ads behind them.",
    icon: <BarChartIcon />,
  },
  {
    href: "/ml",
    title: "ML",
    description: "Machine Learning Model of companies that are likely to move within 1 year.",
    icon: <DesktopIcon />,
  },
];

export const SCORING_FILTERS_ITEMS: MenuItem[] = [
  {
    href: "/score-filter",
    title: "Score Filters",
    description: "View and manage scoring criteria for heat filters.",
    icon: <ArchiveIcon />,
  },
];

export const ANNUAL_REPORTS_ITEMS: MenuItem[] = [
  {
    href: "/annual-report/upload",
    title: "Upload",
    description: "Upload PDF reports and let AI extract company details and scenarios.",
    icon: <FileTextIcon />,
  },
  {
    href: "/annual-report/view",
    title: "View",
    description: "Browse all uploaded annual reports and extracted events.",
    icon: <ArchiveIcon />,
  },
];

export const INSTRUCTIONS_PLUGINS_ITEMS: MenuItem[] = [
  {
    href: "/cli-documentation",
    title: "CLI Documentation",
    description: "Read the Bloodline CLI installation and usage guide.",
    icon: <GoTerminal />,
  },
  {
    href: "/admin/claude-mcp",
    title: "MCP instructions",
    description: "Connect Claude to the Bloodline MCP server.",
    icon: <LightningBoltIcon />,
  },
  {
    href: "/linkedin-extension",
    title: "Browser extension instructions",
    description: "Install the Bloodline extension and save LinkedIn company information.",
    icon: <MdOutlineSimCardDownload />,
  },
];

export const ADMIN_ITEMS: MenuItem[] = [
  {
    href: "/admin/source-health",
    title: "Source Health",
    description: "Review source freshness and ingestion failures.",
    icon: <ActivityLogIcon />,
  },
  {
    href: "/admin/career-scraper",
    title: "Career Scraper",
    description: "Review career discovery failures and manage company crawls.",
    icon: <ActivityLogIcon />,
  },
  {
    href: "/import",
    title: "Import",
    description: "Import CSV lists from LinkedIn Sales Navigator, 6sense or with tags to enrich Bloodline.",
    icon: <MdOutlineSimCardDownload />,
  },
  // {
  //   href: "/bulk",
  //   title: "Bulk import",
  //   description: "Bulk actions for importing new companies",
  //   icon: <RiFolderDownloadLine />,
  // },
];
